'use strict'
const merge = require('webpack-merge')
const prodEnv = require('./prod.env')

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"',
  API: '"http://localhost:3001/api/v1/"',
  MP_TOKEN: 'TEST-dfd0add1-f6f7-4f8c-9bfb-d9538c7d5249',
  FILES_URL: 'http://localhost:3002/uploads/'
})



//////////////////
// WEBPACK FOOTER
// ./config/dev.env.js
// module id = dhIU
// module chunks = 15